var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListaBrindes',{attrs:{"campanha":_vm.item,"itemsSelected":_vm.item.brindes,"select-callback":_vm.addBrinde,"deselect-callback":_vm.removeBrinde,"update-quantity-callback":_vm.updateBrindeQuantity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }